var render = function render() {
  var _vm$subMenuList$0$chi;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "sub-menu"
  }, [_vm.subMenuList[0] && ((_vm$subMenuList$0$chi = _vm.subMenuList[0].children) === null || _vm$subMenuList$0$chi === void 0 ? void 0 : _vm$subMenuList$0$chi.length) > 0 ? _vm._l(_vm.subMenuList, function (item, index) {
    return _c("section", {
      key: index,
      staticClass: "sub-menu__catalog"
    }, [item.menu_name ? _c("h4", [_vm._v(_vm._s(item.menu_name))]) : _vm._e(), _c("ul", _vm._l(item.children, function (ele, i) {
      return _c("li", {
        key: i,
        on: {
          click: function ($event) {
            return _vm.handleClickSubMenu(ele);
          }
        }
      }, [_vm._v(" " + _vm._s(ele.menu_name) + " ")]);
    }), 0)]);
  }) : _vm.subMenuList[0] ? [_c("section", {
    staticClass: "sub-menu__catalog"
  }, [_c("ul", _vm._l(_vm.subMenuList, function (ele, i) {
    return _c("li", {
      key: i,
      on: {
        click: function ($event) {
          return _vm.handleClickSubMenu(ele);
        }
      }
    }, [_vm._v(" " + _vm._s(ele.menu_name || ele.name) + " ")]);
  }), 0)])] : _vm._e(), _c("a-modal", {
    attrs: {
      title: "申请试用",
      okText: "提交"
    },
    on: {
      ok: _vm.handleOk,
      cancel: _vm.handleCancel
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("div", [_c("a-form", {
    attrs: {
      form: _vm.form
    }
  }, [_c("a-form-item", {
    attrs: {
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      },
      label: "试用产品"
    }
  }, [_c("a-checkbox-group", {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ["checkValue", {
        initialValue: _vm.editForm.checkValue,
        rules: [{
          required: true,
          message: ""
        }]
      }],
      expression: "[\n              'checkValue',\n              { initialValue: editForm.checkValue, rules: [{ required: true, message: '' }] },\n            ]"
    }],
    attrs: {
      options: _vm.defaultArr
    },
    on: {
      change: _vm.onChange
    },
    model: {
      value: _vm.checkedList,
      callback: function ($$v) {
        _vm.checkedList = $$v;
      },
      expression: "checkedList"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      },
      label: "试用说明"
    }
  }, [_c("a-input", {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ["explain", {
        initialValue: _vm.editForm.explain,
        rules: [{
          required: true,
          message: ""
        }]
      }],
      expression: "[\n              'explain',\n              { initialValue: editForm.explain, rules: [{ required: true, message: '' }] },\n            ]"
    }],
    attrs: {
      type: "textarea",
      "show-count": "",
      maxLength: 300,
      placeholder: "请提供您的同花顺销售姓名或提供详细的试用说明，可帮助您快速获得试用权限",
      rows: 4
    },
    model: {
      value: _vm.editForm.explain,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "explain", $$v);
      },
      expression: "editForm.explain"
    }
  })], 1)], 1)], 1)])], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };